import React, { useEffect, useState, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiPost } from '../api/client';
import type { ConfirmEmailRequest, MessageResponse } from '../types/api';
import AlertMessage from '../components/AlertMessage';
import LoadingSpinner from '../components/LoadingSpinner';
import './ConfirmEmailPage.css';

export default function ConfirmEmailPage() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const userId = searchParams.get('userId');
    const token = searchParams.get('token');

    if (!userId || !token) {
      setError('Invalid confirmation link.');
      setLoading(false);
      return;
    }

    (async () => {
      try {
        const body: ConfirmEmailRequest = { userId, token };
        const data = await apiPost<MessageResponse>('/api/auth/confirm-email', body);
        setSuccess(data.message);
      } catch (err: any) {
        setError(err.message || 'Email confirmation failed.');
      } finally {
        setLoading(false);
      }
    })();
  }, [searchParams]);

  return (
    <div className="auth-page">
      <div className="auth-container confirm-email-status">
        <h1 className="auth-title">Cedar Vault</h1>
        <p className="auth-subtitle">Email Confirmation</p>
        <div className="divider" />

        {loading && <LoadingSpinner />}
        <AlertMessage type="success" message={success} />
        <AlertMessage type="error" message={error} />

        {!loading && (
          <div className="auth-links">
            <Link to="/login">Go to sign in</Link>
          </div>
        )}
      </div>
    </div>
  );
}
